import I18n from 'I18n';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Heading } from 'foundations-components/transitional/components/Heading';
import ChecklistItemTranslated from '../../common/ChecklistItemTranslated';
import { FeaturesLayoutUI } from './FeaturesLayoutUI';
import { jsx as _jsx } from "react/jsx-runtime";
export const CreditsFeatures = ({
  hubSpotCreditsFeature,
  size,
  isCollapsible = false,
  loading
}) => {
  const VALUE_PROPS_COPY = {
    BREEZE: {
      SMALL: {
        features: [I18n.text('merchCards.hubSpotCredits.BREEZE.SMALL.valueProps.feature1'), I18n.text('merchCards.hubSpotCredits.BREEZE.SMALL.valueProps.feature2')]
      },
      MEDIUM: {
        features: [I18n.text('merchCards.hubSpotCredits.BREEZE.MEDIUM.valueProps.feature1'), I18n.text('merchCards.hubSpotCredits.BREEZE.MEDIUM.valueProps.feature2')]
      },
      LARGE: {
        features: [I18n.text('merchCards.hubSpotCredits.BREEZE.LARGE.valueProps.feature1'), I18n.text('merchCards.hubSpotCredits.BREEZE.LARGE.valueProps.feature2')]
      }
    },
    CUSTOMER_AGENT: {
      SMALL: {
        features: [I18n.text('merchCards.hubSpotCredits.CUSTOMER_AGENT.SMALL.valueProps.feature1')]
      },
      MEDIUM: {
        features: [I18n.text('merchCards.hubSpotCredits.CUSTOMER_AGENT.MEDIUM.valueProps.feature1')]
      },
      LARGE: {
        features: [I18n.text('merchCards.hubSpotCredits.CUSTOMER_AGENT.LARGE.valueProps.feature1')]
      }
    }
  };
  const valuePropsKeys = VALUE_PROPS_COPY[hubSpotCreditsFeature][size].features;
  const HeaderSection = /*#__PURE__*/_jsx(View, {
    marginInline: "200",
    children: /*#__PURE__*/_jsx(Heading, {
      children: I18n.text(`merchCards.hubSpotCredits.${hubSpotCreditsFeature}.${size}.valueProps.title`)
    })
  });
  const FeaturesListSection = valuePropsKeys.map((valuePropKey, index) => {
    return /*#__PURE__*/_jsx(Flex, {
      marginBlockStart: index > 0 ? '300' : undefined,
      children: /*#__PURE__*/_jsx(ChecklistItemTranslated, {
        message: valuePropKey
      })
    }, valuePropKey);
  });
  return /*#__PURE__*/_jsx(FeaturesLayoutUI, {
    loading: loading,
    HeaderSection: HeaderSection,
    FeaturesListSection: FeaturesListSection,
    isCollapsible: isCollapsible
  });
};